import { render, staticRenderFns } from "./2024_315.vue?vue&type=template&id=dba26bf8&scoped=true&"
import script from "./2024_315.vue?vue&type=script&lang=js&"
export * from "./2024_315.vue?vue&type=script&lang=js&"
import style0 from "./2024_315.vue?vue&type=style&index=0&id=dba26bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba26bf8",
  null
  
)

export default component.exports